import { V4LciaMethod, V4TransformedLciaMethod } from 'hooks/data/datasets/V4/lcia/types';

export const transformToV3Method = (data: V4LciaMethod): V4TransformedLciaMethod => {
  return {
    method_id: data.id,
    method_name: data.name,
  };
};

export const transformToV3MethodArray = (dataArray: V4LciaMethod[]): V4TransformedLciaMethod[] => {
  return dataArray.map(transformToV3Method);
};
